/**
 * Pain Points section component
 * Displays common challenges that tutors face
 */
function PainPointsSection() {
  // Pain point data array for easy maintenance
  const painPoints = [
    {
      emoji: '⏰',
      title: 'Time-consuming assessments',
      description: 'Creating and grading placement tests takes hours away from actual teaching time.',
    },
    {
      emoji: '👥',
      title: 'Every student is different',
      description: "You're juggling multiple students with different skill levels, learning styles, and knowledge gaps — it's hard to personalize effectively.",
    },
    {
      emoji: '📊',
      title: 'Unclear progress tracking',
      description: "It's challenging to clearly show parents and students exactly where gaps exist and how they're being filled — you need data that's easy to communicate.",
    },
    // {
    //   emoji: '📝',
    //   title: 'Lesson planning overwhelm',
    //   description: "Creating customized lesson plans for each student's needs, takes valuable time that you could spend teaching.",
    // },
  ];

  return (
    <section aria-labelledby="pain-points-title" className="bg-white">
      <div className="mx-auto max-w-7xl mobile-full-width px-4 sm:px-6 lg:px-8 py-12 sm:py-16 lg:py-20">
        <div className="text-center mb-8">
          <h2 id="pain-points-title" className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-slate-900">
            Sound Familiar?
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-2 gap-6 lg:gap-8 max-w-6xl mx-auto">
          {painPoints.map((point, index) => (
            <div key={index} className="card-hover rounded-3xl border-2 border-slate-200 bg-gradient-to-br from-white to-slate-50 p-6 sm:p-10 shadow-modern">
              <div className="text-6xl sm:text-7xl mb-6">{point.emoji}</div>
              <h3 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-4 leading-tight">
                {point.title}
              </h3>
              <p className="text-base sm:text-lg text-slate-600 leading-relaxed">
                {point.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default PainPointsSection;
